import { render } from "./list-notification-items.vue?vue&type=template&id=5150a41b"
import script from "./list-notification-items.vue?vue&type=script&lang=js"
export * from "./list-notification-items.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/main/notification/items/list-notification-items.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5150a41b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5150a41b', __exports__)) {
    console.log('reload')
    api.reload('5150a41b', __exports__)
  }
  
  module.hot.accept("./list-notification-items.vue?vue&type=template&id=5150a41b", () => {
    console.log('re-render')
    api.rerender('5150a41b', render)
  })

}


export default __exports__